import { render } from "./AddRoom.vue?vue&type=template&id=0798aed5"
import script from "./AddRoom.vue?vue&type=script&lang=js"
export * from "./AddRoom.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__